import SVGConverter from "./svg_converter";

export default class SVGConverterTask {

    //#region instance

    static instance = null;

    static get Instance() {
        if (this._instance == null) {
            this._instance = new SVGConverterTask();
        }

        return this._instance;
    }

    //#endregion

    task = new Map();

    constructor() { }

    /**
     * 新增轉換器
     * @param {*} target 目標對象
     * @param {*} width canvas寬度
     * @param {*} height canvas高度
     */
    add(type, target, width, height) {
        if (!this.task.has()) {
            this.task.set(type, new SVGConverter(target, width, height));
        }
    }

    /**
     * 設定轉換參數
     * @param {*} target 
     * @param {{
     *  url: string, 
     *  scale: number, 
     *  offsetX: number, 
     *  offsetY: number
     * }} options 
     */
    set(type, options) {
        const converter = this.task.get(type);

        if (converter) {
            if (options.url !== null || options.url !== undefined) converter.url = options.url;
            if (options.scale !== null || options.scale !== undefined) converter.scale = options.scale;
            if (options.offsetX !== null || options.offsetX !== undefined) converter.offsetX = options.offsetX;
            if (options.offsetY !== null || options.offsetY !== undefined) converter.offsetY = options.offsetY;
        }
    }
}